import { IMappingEntity } from './interface-mapping-entity';
import { P2PMetadataEntityBase } from './abstract-p2p-metadata-entity-base';

/**
 * æ å°è§åå®ä½æ½è±¡ç±»
 */
export abstract class MappingEntity extends P2PMetadataEntityBase implements IMappingEntity {
    IsEnabled: boolean;

    MappingMetadataId: string;

    MappingRuleId: string;

    MappingComponentMetadataId: string;

    MappingComponentId: string;
}